import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import axios from "axios";
import logoLeft from "../../assets/img/logo/new-logo.png";
import logoRight from "../../assets/img/logo/punjab-logo.png";

const translateText = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ur&dt=t&q=${encodeURIComponent(text)}`
    );
    const json = await res.json();
    return json?.[0]?.map((part) => part[0]).join(" ") || text;
  } catch {
    return text;
  }
};

const VVIPRoaster = () => {
  const englishRef = useRef();
  const urduRef = useRef();
  const englishBtnRef = useRef();
  const urduBtnRef = useRef();

  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 31;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentMonthYear, setCurrentMonthYear] = useState("");
  const [urduDayMap, setUrduDayMap] = useState({});
  const [urduDoctorMap, setUrduDoctorMap] = useState({});
  const [isScreenshot, setIsScreenshot] = useState(false);

  useEffect(() => {
    const date = new Date();
    const monthYear = date.toLocaleDateString("ur-PK", {
      year: "numeric",
      month: "long",
    });
    setCurrentMonthYear(monthYear);
  }, []);

  useEffect(() => {
    if (startDate && endDate) fetchRoasterData(startDate, endDate);
  }, [startDate, endDate]);

  const fetchRoasterData = async (start, end) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `https://ricgop.online/backend/getVVIPRoaster.php?start=${start}&end=${end}`
      );
      if (Array.isArray(res.data)) {
        setEntries(res.data);

        const uniqueDays = [...new Set(res.data.map((e) => e.day).filter(Boolean))];
        const uniqueDoctors = new Set();
        res.data.forEach((e) => {
          if (e.morning) uniqueDoctors.add(e.morning);
          if (e.evening) uniqueDoctors.add(e.evening);
          if (e.dms_night) uniqueDoctors.add(e.dms_night);
        });

        const urduDays = {};
        for (const day of uniqueDays) {
          urduDays[day] = await translateText(day);
        }

        const urduDoctors = {};
        for (const name of uniqueDoctors) {
          urduDoctors[name] = await translateText(name);
        }

        setUrduDayMap(urduDays);
        setUrduDoctorMap(urduDoctors);
      } else {
        setEntries([]);
      }
    } catch (err) {
      console.error("❌ Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };


  

const handleScreenshot = async (ref, btnRef, filename) => {
  setIsScreenshot(true); // ✅ Hide Actions

  if (btnRef?.current) btnRef.current.style.display = "none";
  await new Promise((r) => setTimeout(r, 100));

  const canvas = await html2canvas(ref.current, {
    scale: 2,
    width: 794,
    height: 1123,
  });

  const link = document.createElement("a");
  link.href = canvas.toDataURL("image/png");
  link.download = filename;
  link.click();

  if (btnRef?.current) btnRef.current.style.display = "inline-block";

  setIsScreenshot(false); // ✅ Restore Actions
};


  const totalPages = Math.ceil(entries.length / pageSize);
  const paginatedData = entries.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.toLocaleString("en-US", { month: "long" });
    return `${day}-${month}`;
  };

  return (
    <div>

         {/* 🔷 Responsive Navbar */}
    <nav className="navbar navbar-expand-lg bg-white shadow-sm px-4 py-3 mb-4 rounded-bottom-4">
      <div className="container-fluid">
        <a className="navbar-brand fw-bold text-primary fs-4" href="/">
          🏥 RIC Duty Panel
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto align-items-center gap-lg-3 mt-3 mt-lg-0">

            {/* 🔽 Roasters Dropdown */}
            <li className="nav-item dropdown">
              <button
                className="btn btn-outline-secondary dropdown-toggle rounded-3 w-100"
                type="button"
                id="roastersDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                📁 Roasters
              </button>
              <ul className="dropdown-menu" aria-labelledby="roastersDropdown">
                <li><a className="dropdown-item" href="/entry/roaster/dutylist">Part 1 Duty Roaster</a></li>
                <li><a className="dropdown-item" href="/entry/roaster/ams">AMS Roaster</a></li>
                <li><a className="dropdown-item" href="/entry/roaster/vvip">VVIP Movement Roaster</a></li>
              </ul>
            </li>

            {/* 📋 Duty Forms */}
            <li className="nav-item">
              <button
                className="btn btn-outline-primary rounded-3 w-100"
                onClick={() => window.location.href = "/entry/roaster/dutyform"}
              >
                📋 Duty Forms
              </button>
            </li>

            {/* 🚪 Logout */}
            <li className="nav-item">
              <button
                className="btn btn-outline-danger rounded-3 w-100"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = "/roaster/login";
                }}
              >
                🚪 Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
<div
  style={{
    fontFamily: "'Noto Nastaliq Urdu', serif",
    fontSize: "18px",
    lineHeight: "1.8",
    color: "#212529",
    direction: "rtl",
    textAlign: "right",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // centers inner box
  }}
>
  {/* Urdu Filter Inputs */}
  <div style={{ textAlign: "center", marginBottom: 20 }}>
    <input
      type="date"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
      style={inputStyle}
    />
    <input
      type="date"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
      style={inputStyle}
    />
  </div>
  {/* Urdu Table Section */}
  <div
    ref={urduRef}
    style={{
      ...a4PortraitStyle,
      maxWidth: "900px",
      direction: "rtl",
      textAlign: "right",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      borderRadius: "10px",
      padding: "20px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    }}
  >
  <Header isUrdu currentMonthYear={currentMonthYear} />
    <Title isUrdu currentMonthYear={currentMonthYear} />
    <Table
      data={paginatedData}
      loading={loading}
      isUrdu
      urduDayMap={urduDayMap}
      urduDoctorMap={urduDoctorMap}
      formatDate={formatDate}
    />
    <Footer isUrdu />
    <div style={{ textAlign: "center", marginTop: 20 }}>
      <ScreenshotButton
        refBtn={urduBtnRef}
        onClick={() =>
          handleScreenshot(urduRef, urduBtnRef, "VVIP_Urdu.png")
        }
      />
    </div>
    </div>
{/* English Table Wrapper */}
<div
  style={{
    fontFamily: "sans-serif",
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#000",
    direction: "ltr",
    textAlign: "left",
    padding: 20,
  }}
></div>

{/* English Table Section */}
  <div
    ref={englishRef}
    style={{
      ...a4PortraitStyle,
      direction: "ltr",
      textAlign: "left",
      marginLeft: "auto", // align table to the left
      marginRight: 0,
    }}
  >
    <Header currentMonthYear={currentMonthYear} />
    <Title currentMonthYear={currentMonthYear} />
    <Table
      data={paginatedData}
      loading={loading}
      formatDate={formatDate}
      fetchData={() => fetchRoasterData(startDate, endDate)}
      isScreenshot={isScreenshot}
    />
    <Footer />
    <ScreenshotButton
      refBtn={englishBtnRef}
      onClick={() =>
        handleScreenshot(englishRef, englishBtnRef, "VVIP_English.png")
      }
    />
  </div>


      {/* Pagination */}
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} style={btnStyle}>⬅️ Prev</button>
        <span style={{ margin: "0 10px" }}>Page {currentPage} of {totalPages}</span>
        <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} style={btnStyle}>Next ➡️</button>
      </div>
    </div>
    </div>
  );
};

const Table = ({ data, loading, isUrdu, urduDayMap = {}, urduDoctorMap = {}, formatDate, fetchData, isScreenshot = false }) => {
  const [editIndex, setEditIndex] = useState(null);
  const [formData, setFormData] = useState({});

  const handleEdit = (index, entry) => {
    setEditIndex(index);
    setFormData(entry);
  };



  const handleDelete = async (date, day) => {
  if (window.confirm("Are you sure you want to delete this entry?")) {
    await axios.post("https://ricgop.online/backend/delete-entry.php", { date, day });
    fetchData();
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    await axios.post("https://ricgop.online/backend/update-entry.php", formData);
    setEditIndex(null);
    fetchData();
  };

  return (
    
    <table style={{ width: "100%", marginTop: 10, borderCollapse: "collapse", fontSize: 10.5, lineHeight: 1.1 }}>
     <thead>
 <tr style={{ backgroundColor: "#0d6efd", color: "#fff" }}>
  {(isUrdu
    ? ["تاریخ", "دن", "صبح", "شام", "ڈی ایم ایس نائٹ"]
    : ["Date", "Day", "Morning", "Evening", "DMS Night"].concat(isScreenshot ? [] : ["Actions"])
  ).map((text, idx) => (
    <th key={idx} style={cellStyle}>{text}</th>
  ))}
</tr>
</thead>

     <tbody>
  {loading ? (
    <tr>
      <td colSpan={isUrdu || isScreenshot ? 5 : 6} style={{ textAlign: "center", padding: 20 }}>Loading...</td>
    </tr>
  ) : data.map((entry, i) => {
    const isSunday = entry.day?.toLowerCase() === "sunday";
    const isEditing = editIndex === i;

    return (
      <tr
        key={i}
        style={{
          backgroundColor: isSunday ? "#ffe2e2" : i % 2 === 0 ? "#f9f9f9" : "#fff",
          fontWeight: isSunday ? "bold" : "normal"
        }}
      >
        <td style={cellStyle}>
          {isEditing && !isUrdu && !isScreenshot
            ? <input name="date" value={formData.date} onChange={handleChange} style={{ width: "100%" }} />
            : (isUrdu ? (urduDayMap[entry.date] || entry.date) : formatDate(entry.date))
          }
        </td>
        <td style={cellStyle}>
          {isEditing && !isUrdu && !isScreenshot
            ? <input name="day" value={formData.day} onChange={handleChange} style={{ width: "100%" }} />
            : (isUrdu ? (urduDayMap[entry.day] || entry.day) : entry.day)
          }
        </td>
        <td style={cellStyle}>
          {isEditing && !isUrdu && !isScreenshot
            ? <input name="morning" value={formData.morning} onChange={handleChange} style={{ width: "100%" }} />
            : (isUrdu ? (urduDoctorMap[entry.morning] || entry.morning || "-") : entry.morning || "-")
          }
        </td>
        <td style={cellStyle}>
          {isEditing && !isUrdu && !isScreenshot
            ? <input name="evening" value={formData.evening} onChange={handleChange} style={{ width: "100%" }} />
            : (isUrdu ? (urduDoctorMap[entry.evening] || entry.evening || "-") : entry.evening || "-")
          }
        </td>
        <td style={cellStyle}>
          {isEditing && !isUrdu && !isScreenshot
            ? <input name="dms_night" value={formData.dms_night} onChange={handleChange} style={{ width: "100%" }} />
            : (isUrdu ? (urduDoctorMap[entry.dms_night] || entry.dms_night || "-") : entry.dms_night || "-")
          }
        </td>

       {!isUrdu && !isScreenshot && (
  <td style={cellStyle}>
    {isEditing ? (
      <>
        <button onClick={handleSave}>💾</button>
        <button onClick={() => setEditIndex(null)}>❌</button>
      </>
    ) : (
      <>
        <button onClick={() => handleEdit(i, entry)}>✏️</button>
        <button onClick={() => handleDelete(entry.date, entry.day)}>🗑️</button>
      </>
    )}
  </td>
)}
      </tr>
    );
  })}
</tbody>

    </table>
  );
};

const Header = ({ isUrdu }) => (
  <div style={{ textAlign: "center", position: "relative", paddingBottom: 5, marginBottom: 10, borderBottom: "1px solid #0d6efd" }}>
    <img src={logoRight} style={{ height: 55, position: "absolute", left: 10, top: 10 }} alt="right" />
    <img src={logoLeft} style={{ height: 55, position: "absolute", right: 10, top: 10 }} alt="left" />
    {/* <h4 style={{ marginBottom: 2 }}>{isUrdu ? "دفتر میڈیکل سپرنٹنڈنٹ" : "Office of the Medical Superintendent"}</h4> */}
    <p style={{ margin: 0 }}>{isUrdu ? "راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی، راول روڈ، راولپنڈی" : "Rawalpindi Institute of Cardiology, Rawal Road, Rawalpindi"}</p>
    <p style={{ margin: 0 }}>{isUrdu ? "RIC / Admin / _______ / 2025" : "No: RIC / Admin / _______ / 2025"}</p>
    <p style={{ margin: 0 }}>{isUrdu ? "تاریخ: ___ / ___ / 2025" : "Dated: ____ / ____ / 2025"}</p>
  </div>
);

const Title = ({ isUrdu, currentMonthYear }) => (
  <div style={{ textAlign: "center", backgroundColor: "#d1e7dd", border: "1px solid #198754", padding: 2, borderRadius: 3 }}>
    <h6 style={{ margin: 0 }}>{isUrdu ? `وی وی آئی پی موومنٹ روسٹر - ${currentMonthYear}` : `VVIP Movement Roaster - ${currentMonthYear}`}</h6>
  </div>
);

const Footer = ({ isUrdu }) => (
  <div style={{ marginTop: 20, fontSize: "9px" }}>
    <div>
      <p style={{ fontSize: "12px", lineHeight: "1.5" }}><strong>{isUrdu ? "وی وی آئی پی موومنٹ کی کوریج کے اصول:" : "VVIP Movement to be covered as per:-"}</strong></p>
      <p style={{ fontSize: "10px" }}>{isUrdu ? "1۔ پہلی وی وی آئی پی موومنٹ روستر کے مطابق، دوسری او پی ڈی، اور تیسری ڈی ایم ایس ایمرجنسی مارننگ کور کرے گا۔" : "1. In case of the first VVIP movement, it will be covered as per roster. The second will be covered by OPD and the third by DMS Emergency Morning."}</p>
      <p style={{ fontSize: "10px" }}>{isUrdu ? "2۔ شام کی پہلی موومنٹ روستر کے مطابق، جبکہ دوسری ڈی ایم ایس ایوننگ کور کرے گا۔" : "2. In the evening, the first movement will be covered as per roster, and the second by DMS Evening."}</p>
      <p style={{ fontSize: "10px" }}>{isUrdu ? "3۔ رات کی پہلی موومنٹ ڈی ایم ایس نائٹ کور کرے گا، دوسری صورت میں ایمرجنسی روم سے پی جی کور کرے گا۔" : "3. At night, the first movement will be covered by DMS Night. In case of a second movement, it will be covered by a PG from the E.R."}</p>
      <p style={{ fontSize: "10px" }}>{isUrdu ? "4۔ اگر کسی افسر کو ڈیوٹی کے دن چھٹی درکار ہو، تو اسے متبادل کا بندوبست کرنا ہوگا۔" : "4. The officer must arrange for a substitute in the event of leave on a duty day."}</p>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
      <div style={{ textAlign: "center" }}>
             <p>---------------------------</p>
        <p style={{ fontSize: "10px", margin: 0, fontWeight: "bold" }}>{isUrdu ? "میڈیکل سپرنٹنڈنٹ" : "Medical Superintendent"}</p>
        <p style={{ fontSize: "10px", margin: 0 }}>{isUrdu ? "راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی" : "Rawalpindi Institute of Cardiology"}</p>
        <p style={{ fontSize: "10px", margin: 0 }}>{isUrdu ? "راولپنڈی" : "Rawalpindi"}</p>
      </div>
    </div>
  </div>
);



const ScreenshotButton = ({ onClick, refBtn }) => (
  <div style={{ textAlign: "center", marginTop: 20 }}>
    <button onClick={onClick} ref={refBtn} style={btnStyle}>📸 Screenshot</button>
  </div>
);

const a4PortraitStyle = {
  width: "794px",
  minHeight: "1123px",
  background: "white",
  padding: 40,
  borderRadius: 10,
  margin: "40px auto",
  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
};

const thStyle = {
  padding: 10,
  border: "1px solid #ccc",
  textAlign: "center"
};

const tdStyle = {
  padding: 8,
  border: "1px solid #ddd",
  textAlign: "center"
};

const inputStyle = {
  margin: "0 10px",
  padding: "6px 12px",
  fontSize: "15px"
};

const btnStyle = {
  backgroundColor: "#0d6efd",
  color: "#fff",
  padding: "8px 16px",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer",
  margin: "0 5px"
};

// Cell style used in both <td> and <th>
const cellStyle = {
  padding: "4px 5px",
  border: "1px solid #ddd",
  textAlign: "center",
  verticalAlign: "middle"
};
export default VVIPRoaster;
